export function showSlicedText(text) {
  return text.length > 12 ? [text?.slice(0, 4), text.slice(text?.length - 4)].join('...') : text;
}
export function copyText(text) {
    console.log(text,'copy');
    navigator.clipboard.writeText(text);
}
